import type { Branch } from '@/api/types'

/**
 * How a branch is named on screen.
 *
 * No module owns branches as records yet, so the API sends a null code and name and tells the
 * client so through `directoryAvailable`. The identifier is then the only true thing available, and
 * showing it is the honest answer: a bare "Branch" names nothing, and an invented label would be a
 * name the institution never gave this branch.
 *
 * Code before name because that is what staff say to each other — a branch is "PA-002" long before
 * anyone reads out its full name — and the header has room for one of the two.
 */
export function branchLabel(branch: Branch | null | undefined): string {
  if (!branch) {
    return 'No branch'
  }

  return branch.code ?? branch.name ?? `Branch ${branch.id}`
}

/** The fuller form, for a picker with room for both. */
export function branchDescription(branch: Branch): string {
  if (branch.code && branch.name) {
    return `${branch.code} — ${branch.name}`
  }

  return branchLabel(branch)
}
